var __typeError = (msg) => {
  throw TypeError(msg);
};
var __accessCheck = (obj, member, msg) => member.has(obj) || __typeError("Cannot " + msg);
var __privateGet = (obj, member, getter) => (__accessCheck(obj, member, "read from private field"), getter ? getter.call(obj) : member.get(obj));
var __privateAdd = (obj, member, value) => member.has(obj) ? __typeError("Cannot add the same private member more than once") : member instanceof WeakSet ? member.add(obj) : member.set(obj, value);
var __privateMethod = (obj, member, method) => (__accessCheck(obj, member, "access private method"), method);
var _updateHeaderCartIcon, _HeaderCartIcon_instances, formatCartCount_fn;
import { C as Component } from "./component-cLJ9vlHA.js";
import { C as CustomEvents } from "./events-DeC3n8dp.js";
import "./critical-Da0Dmhh9.js";
import "./utilities-2Suih3Nm.js";
class HeaderCartIcon extends Component {
  constructor() {
    super(...arguments);
    __privateAdd(this, _HeaderCartIcon_instances);
    __privateAdd(this, _updateHeaderCartIcon, (event) => {
      const { cartIconFilled, cartIconEmpty, cartText, cartIconDot } = this.refs;
      const itemCount = event.detail.data.itemCount;
      const isEmpty = itemCount === 0;
      cartIconFilled.classList.toggle("hidden", isEmpty);
      cartIconEmpty.classList.toggle("hidden", !isEmpty);
      this.dataset.cartCount = itemCount;
      if ((cartIconDot == null ? void 0 : cartIconDot.dataset.type) === "number") {
        cartIconDot.querySelectorAll(".text-custom-content-inner span").forEach((span) => {
          span.textContent = __privateMethod(this, _HeaderCartIcon_instances, formatCartCount_fn).call(this, itemCount);
        });
      }
      if (cartText) {
        cartText.classList.toggle("hidden", itemCount === 0);
        cartText.textContent = itemCount;
      }
    });
  }
  connectedCallback() {
    super.connectedCallback();
    document.addEventListener(CustomEvents.cartUpdate, __privateGet(this, _updateHeaderCartIcon));
    document.addEventListener(CustomEvents.cartAdd, __privateGet(this, _updateHeaderCartIcon));
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    document.removeEventListener(CustomEvents.cartUpdate, __privateGet(this, _updateHeaderCartIcon));
    document.removeEventListener(CustomEvents.cartAdd, __privateGet(this, _updateHeaderCartIcon));
  }
}
_updateHeaderCartIcon = new WeakMap();
_HeaderCartIcon_instances = new WeakSet();
formatCartCount_fn = function(count) {
  return count > 9 ? "9+" : count;
};
if (!customElements.get("header-cart-icon")) {
  customElements.define("header-cart-icon", HeaderCartIcon);
}
